(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/jotai/atoms.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/jotai/atoms.js');
"use strict";

var _svs$utils$paramHandl, _svs$utils$paramHandl2;

const _jotai = jotai,
  atom = _jotai.atom;
const atomWithSvSStorage = svs.lyckoplatsen.shared_utils.atomWithSvSStorage;
const _svs$tur$lyckoplatsen = svs.tur.lyckoplatsen.map,
  swe = _svs$tur$lyckoplatsen.swe,
  isPointInsideSweden = _svs$tur$lyckoplatsen.isPointInsideSweden;
const showOutOfSwedenError = svs.lyckoplatsen.components.page_play.utils.showOutOfSwedenError;
const wager = svs.lyckoplatsen.data.preloadedWager;
const CONSTANTS = svs.lyckoplatsen.components.shared_constants.CONSTANTS;
const hasWager = Boolean(wager);
const hasActiveSubscription = svs.lyckoplatsen.data.hasActiveSubscription;
const isSelfService = svs.core.config.data.svsconfig.isSelfService;
const getDefaultLocationName = svs.tur.lyckoplatsen.utils.getDefaultLocationName;
const DRAW_PARAM = 'dragningar';
const SUBSCRIBE_PARAM = 'prenumerera';
let lat = null;
let lng = null;
let defaultPinLocationType = CONSTANTS.LOCATION_TYPES.OTHER;
let defaultLocationName = getDefaultLocationName();
let defaultLocationConfirmed = false;
let storageKeySuffix = '';
let forceUseOldLocation = false;
if (hasWager) {
  defaultPinLocationType = wager.wager.bets[0].geoBoardData.geoLocType;
  defaultLocationConfirmed = true;
  lat = wager.wager.bets[0].geoBoardData.geoLoc.latitude.replace(',', '.');
  lng = wager.wager.bets[0].geoBoardData.geoLoc.longitude.replace(',', '.');
  defaultLocationName = wager.wager.bets[0].geoBoardData.geoLocName;
  storageKeySuffix = "-".concat(wager.wagerId);
  const locationConfirmed = svs.components.Storage.browser.get("locationConfirmed-".concat(wager.wagerId), 'lyckoplatsen');
  forceUseOldLocation = !locationConfirmed;
}
const defaultPlayValues = {
  pinLocationTypeAtom: defaultPinLocationType,
  disableCenterMapButtonAtom: true,
  locationConfirmedAtom: defaultLocationConfirmed,
  mapLocationAtom: {
    lat: null,
    lng: null
  },
  pinLocationAtom: {
    lat,
    lng
  },
  shouldAutoPayAtom: false,
  shouldShowPinAtom: false,
  shouldDisablePayButtonAtom: false,
  locationNameAtom: defaultLocationName,
  shouldPayAfterDepositAtom: false
};
const payParam = (_svs$utils$paramHandl = svs.utils.paramHandler.get({
  key: 'pay'
})) === null || _svs$utils$paramHandl === void 0 ? void 0 : _svs$utils$paramHandl.value;
const forceSubscription = ((_svs$utils$paramHandl2 = svs.utils.paramHandler.get({
  key: DRAW_PARAM
})) === null || _svs$utils$paramHandl2 === void 0 ? void 0 : _svs$utils$paramHandl2.value) === SUBSCRIBE_PARAM;
if (forceSubscription) {
  svs.utils.paramHandler.remove({
    key: DRAW_PARAM
  });
}
const isDefaultSubscription = !payParam && hasActiveSubscription && !hasWager && !isSelfService;
const initNumberOfWeeks = forceSubscription || isDefaultSubscription ? 0 : CONSTANTS.DRAWS.NUMBER_OF_WEEKS;
const atoms = {
  isProlonginationAtom: atom(get => {
    const pinLocation = get(atoms.pinLocationAtom);
    if (!hasWager) {
      return false;
    }
    const hasSameCoordinates = lat === pinLocation.lat && lng === pinLocation.lng;
    return hasSameCoordinates;
  }),
  numberOfWeeksAtom: atomWithSvSStorage("numberOfWeeks".concat(storageKeySuffix), initNumberOfWeeks, null, forceSubscription),
  lyckoplatsenNameAtom: atomWithSvSStorage("lyckoplatsenName".concat(storageKeySuffix), defaultPlayValues.locationNameAtom),
  shouldAutoPayAtom: atom(defaultPlayValues.shouldAutoPayAtom),
  shouldPayAfterDepositAtom: atom(defaultPlayValues.shouldPayAfterDepositAtom),
  pinLocationTypeAtom: atomWithSvSStorage("pinLocationType".concat(storageKeySuffix), defaultPlayValues.pinLocationTypeAtom, null, forceUseOldLocation),
  disableCenterMapButtonAtom: atom(defaultPlayValues.disableCenterMapButtonAtom),
  locationConfirmedAtom: atomWithSvSStorage("locationConfirmed".concat(storageKeySuffix), defaultPlayValues.locationConfirmedAtom, null, forceUseOldLocation),
  mapLocationAtom: atom(defaultPlayValues.mapLocationAtom),
  shouldDisablePayButtonAtom: atom(defaultPlayValues.shouldDisablePayButtonAtom),
  shouldShowOverlayAtom: atom(false),
  isDefaultSubscriptionAtom: atom(isDefaultSubscription),
  storedPinLocationAtom: atomWithSvSStorage("pinLocation".concat(storageKeySuffix), defaultPlayValues.pinLocationAtom, null, forceUseOldLocation),
  pinLocationAtom: atom(get => get(atoms.storedPinLocationAtom), (_get, set, value) => {
    const _ref = value !== null && value !== void 0 ? value : {},
      _ref$lat = _ref.lat,
      lat = _ref$lat === void 0 ? null : _ref$lat,
      _ref$lng = _ref.lng,
      lng = _ref$lng === void 0 ? null : _ref$lng;
    const formattedLat = parseFloat(lat).toFixed(6);
    const formattedLng = parseFloat(lng).toFixed(6);
    if (!value || !value.lat || !value.lng) {
      set(atoms.storedPinLocationAtom, false);
      return;
    }
    const inSweTerritory = isPointInsideSweden([formattedLat, formattedLng], swe.features[0].geometry.coordinates);
    if (parseFloat(formattedLat) && parseFloat(formattedLng) && !inSweTerritory) {
      showOutOfSwedenError();
      return;
    }
    const updatedValue = {
      lat: formattedLat.toString(),
      lng: formattedLng.toString()
    };
    set(atoms.storedPinLocationAtom, updatedValue);
  }),
  shouldShowPinAtom: atom(defaultPlayValues.shouldShowPinAtom, (get, set, update) => {
    const pinLocation = get(atoms.pinLocationAtom);
    if (pinLocation.lat && pinLocation.lng) {
      set(atoms.shouldShowPinAtom, update);
      return;
    }
    set(atoms.shouldShowPinAtom, false);
  }),
  isGameValidAtom: atom(get => {
    const pinLocationType = get(atoms.pinLocationTypeAtom);
    const pinLocation = get(atoms.pinLocationAtom);
    return Boolean(pinLocationType && (pinLocation === null || pinLocation === void 0 ? void 0 : pinLocation.lat) && (pinLocation === null || pinLocation === void 0 ? void 0 : pinLocation.lng));
  }),
  newCustomerCampaignAtom: atom(() => {
    var _svs$utils$paramHandl3, _svs$utils$paramHandl4;
    let isActive = false;
    if (svs.core.detect.feature('ft-nummer-lyckoplatsen-new-customer-campaign') && ((_svs$utils$paramHandl3 = svs.utils.paramHandler.get({
      key: 'campaignId'
    })) === null || _svs$utils$paramHandl3 === void 0 ? void 0 : _svs$utils$paramHandl3.value) === CONSTANTS.NEW_CUSTOMER_CAMPAIGN_ID) {
      isActive = true;
    }
    return {
      isActive,
      hasCampaignIdParam: Boolean((_svs$utils$paramHandl4 = svs.utils.paramHandler.get({
        key: 'campaignId'
      })) === null || _svs$utils$paramHandl4 === void 0 ? void 0 : _svs$utils$paramHandl4.value),
      isUserEligible: true
    };
  }),
  newCustomerCampaignPlayAtom: atom(false),
  randomLocationTriggerAtom: atom(0),
  isRandomizingLocationAtom: atom(false)
};
setGlobal('svs.lyckoplatsen.components.page_play.jotai', {
  atoms,
  defaultPlayValues
});

 })(window);